export default __webpack_public_path__ + "static/death-march-8f7c0309f39338c363e1b7c4876a83ac.jpg";